import { constantRoutes } from "@/router/routes.js";
import { newRoutes } from "@/router/routes.js";
import { getRouters } from "@/api/getRouter";
import Layout from "@/views/layout/main";
import ParentView from "@/components/parentView";
import InnerLink from "@/views/components/InnerLink";
import { getToken } from "@/libs/auth";

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_DEFAULT_ROUTES: (state, routes) => {
      state.defaultRoutes = constantRoutes.concat(routes)
    },
    SET_TOPBAR_ROUTES: (state, routes) => {
      // 顶部导航菜单默认添加向首页
      const index = [{
        path: "home",
        meta: { title: "工作台", icon: "dashboard" }
      }]
      state.topbarRouters = routes.concat(index)
      // state.topbarRouters = routes
    },
    SET_SIDEBAR_ROUTERS: (state, routers) => {
      state.sidebarRouters = routers
    },
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }, route) {
      return new Promise(resolve => {
        const sdata = JSON.parse(JSON.stringify(route))
        const rdata = JSON.parse(JSON.stringify(route))
        const sidebarRoutes = sdata.length ? filterAsyncRouter(sdata) : []
        const rewriteRoutes = rdata.length ? filterAsyncRouter(rdata, false, true) : []
        rewriteRoutes.push({ path: "*", redirect: "/404", hidden: true })
        commit("SET_ROUTES", rewriteRoutes)
        commit("SET_SIDEBAR_ROUTERS", constantRoutes.concat(sidebarRoutes))
        commit("SET_DEFAULT_ROUTES", sidebarRoutes)
        commit("SET_TOPBAR_ROUTES", sidebarRoutes)
        resolve(rewriteRoutes)
      })
    },

    ClearRouter({ commit }) {
      commit("SET_ROUTES", [])
      commit("SET_SIDEBAR_ROUTERS", [])
      commit("SET_DEFAULT_ROUTES", [])
      commit("SET_TOPBAR_ROUTES", [])
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children)
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === "Layout") {
        route.component = Layout
      } else if (route.component === "ParentView") {
        route.component = ParentView
      } else if (route.component === "InnerLink") {
        route.component = InnerLink
      } else {
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type)
    } else {
      delete route["children"]
      delete route["redirect"]
    }
    return true
  })
}

function filterChildren(childrenMap, lastRouter = false) {
  var children = []
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === "ParentView" && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + "/" + c.path
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c))
            return
          }
          children.push(c)
        })
        return
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + "/" + el.path
    }
    children = children.concat(el)
  })
  return children
}

export const loadView = (view) => {
  if (process.env.NODE_ENV === "development") {
    return (resolve) => require([`@/views/${view}`], resolve)
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views/${view}`)
  }
}

export default permission
